<div class="home" id="home">
  <div class="container d-flex justify-content-between align-items-center col-12 h-100">
    <div class="intro col-12 col-lg-6 d-flex flex-column gap-3">
      <span class="chip fw-bold">Full-stack Developer (MEAN)</span>
      <h1 class="home-title text-light m-0 fw-bold">Hi, I'm <span>Shreyash Kalaskar</span> I build things for the web</h1>
      <span class="text-light">I build fast, interactive web apps—from real-time tools to blockchain-integrated games. I focus on seamless user experiences using Angular, PixiJS, and other modern technologies in the Web3 space.
      </span>
      <div class="socials d-flex gap-4">
        <a target="_blank" [href]="environment.github">
          <img src="assets/images/svg/github.svg" alt="github" srcset="">
        </a>
        <a target="_blank" [href]="environment.linkedin">
          <img src="assets/images/linkedin.png" alt="linkedIn" srcset="">
        </a>
        <a target="_blank" [href]="environment.resume">
          <img src="assets/images/svg/docs.svg" alt="resume" srcset="">
        </a>
      </div>
    </div>
    <div class="profile-pic h-100 col-4 d-flex justify-content-center align-items-center d-none d-lg-flex">
      <img src="assets/images/profile-pic.jpg" alt="profile-pic" srcset="">
    </div>
  </div>
</div>
